import { MDText } from 'i18n-react';

import { BulletIcon, IconText } from '@motorway/mw-highway-code';
import { InfoBox } from '@motorway/mw-highway-code/alpha';

import { applyCypressData } from 'Utilities/index';

import LocalTexts from './PreferencesCompleted.texts.json';

import styles from './PreferencesCompleted.scss';

const LocalT = new MDText(LocalTexts.preferencesCompleted);

// eslint-disable-next-line import/prefer-default-export
export const PreferencesCompleted = () => {
  const content = (
    <ul className={styles.content}>
      <li>
        <IconText
          icon={BulletIcon}
          text={LocalT.translate('content.bullet1')}
          variant="small--regular"
        />
      </li>
      <li>
        <IconText
          icon={BulletIcon}
          text={LocalT.translate('content.bullet2')}
          variant="small--regular"
        />
      </li>
    </ul>
  );

  const infobox = (
    <InfoBox
      data-thc-infobox
      content={content}
      heading={LocalT.translate('heading')}
      variant="success"
      {...applyCypressData('scpCompleteInfoBox')}
    />
  );

  return <div className={styles.preferencesCompleted}>{infobox}</div>;
};
